
export class BillReadyForPrintModel {
  public orderBillId: string;
  public venueId: string;
  public discount: number;
  public isPercentage: boolean;


}
